import React from 'react';
import { useTravelerProfileSuggestionsStore } from '../../store';
import DismissAllConfirmModal from './dismiss-all-confirm-modal';
import UnsavedChangesModal from './unsaved-changes-modal';
import SuggestionsFab from './suggestions-fab';

/**
 * Host renders portal-style suggestion-flow UI (dismiss-all confirm,
 * unsaved-changes nav guard, sticky action bar) driven from context state.
 * The entry alert is rendered inline in the page layout via `AiEntryAlert`,
 * since it's a banner rather than a modal.
 */
const SuggestionsHost = () => {
  const ctx = useTravelerProfileSuggestionsStore();
  if (!ctx) return null;

  const {
    isDismissAllConfirmOpen,
    hasAnyUnresolvedOrUncommitted,
    isLoadingSuggestions,
    isSaving,
    cancelDismissAll,
    confirmDismissAll,
    resetReview,
  } = ctx;

  return (
    <>
      <DismissAllConfirmModal
        open={isDismissAllConfirmOpen}
        onCancel={cancelDismissAll}
        onConfirm={confirmDismissAll}
      />
      <UnsavedChangesModal
        when={(isLoadingSuggestions || hasAnyUnresolvedOrUncommitted) && !isSaving}
        onConfirmLeave={resetReview}
      />
      <SuggestionsFab />
    </>
  );
};

export default SuggestionsHost;
